module.exports = __webpack_public_path__ + "static/media/QR-app-store.cdb23134.png";